import { createFileRoute } from '@tanstack/react-router';

import { DepthSelectionForm } from '@/features/risk-assessment/components/depth-selection-form';

export const Route = createFileRoute('/_authenticated/risk-assessment/$id/depth-selection')({
  component: DepthSelectionPage,
});

function DepthSelectionPage() {
  const { id } = Route.useParams();
  return <DepthSelectionForm assessmentId={id} />;
}
